const GRAPHQL_WS_TRANSPORT_ERROR = "graphql-ws-transport-error";
const GRAPHQL_WS_RECONNECTED = "graphql-ws-reconnected";
const GRAPHQL_WS_AUTH_REVOKED = "graphql-ws-auth-revoked";
const GRAPHQL_WS_EXPECTED_CLUSTER_SWITCH = "graphql-ws-expected-cluster-switch";
const GRAPHQL_WS_CANCEL_EXPECTED_CLUSTER_SWITCH = "graphql-ws-cancel-expected-cluster-switch";

export {
  GRAPHQL_WS_TRANSPORT_ERROR,
  GRAPHQL_WS_RECONNECTED,
  GRAPHQL_WS_AUTH_REVOKED,
  GRAPHQL_WS_EXPECTED_CLUSTER_SWITCH,
  GRAPHQL_WS_CANCEL_EXPECTED_CLUSTER_SWITCH,
};
